import axios from 'axios'
import VUE_APP_API_UPLOAD_URL from './getapi/upload'

let apiURL = ''
if (process.env.NODE_ENV === "development") {
  // alert("开发环境");
  apiURL = 'http://proxy.jiankanghao.net:50215/api/v1'
  // apiURL = 'https://api.ss.jiankanghao.net'
}else {
  // alert("生产环境");
  apiURL = VUE_APP_API_UPLOAD_URL
}

var http = axios.create({
	timeout: 80000,
	/*设置请求超时时间*/
	baseURL: apiURL,
	// baseURL: 'http://192.168.0.212:8072/api/v1/',
	headers: {
		'Content-Type': 'application/json;charset=UTF-8;'
	}
});
export default http;



// WEBPACK FOOTER //
// ./src/util/uploadApiConfig.js